var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcErrorPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEDF3",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EB4872"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.094 27.417v-6.042c0-.495.41-.906.906-.906.495 0 .906.41.906.906v6.042c0 .495-.41.906-.906.906a.913.913 0 0 1-.906-.906zM24.758 32.226a.768.768 0 0 1-.217-.073.915.915 0 0 1-.218-.108l-.18-.145a1.27 1.27 0 0 1-.351-.858c0-.314.133-.629.35-.858l.181-.145a.915.915 0 0 1 .218-.109.768.768 0 0 1 .217-.072c.157-.037.327-.037.472 0a.729.729 0 0 1 .23.072c.072.024.144.06.217.109l.18.145c.218.23.351.544.351.858 0 .314-.133.628-.35.858l-.181.145a.915.915 0 0 1-.218.108.729.729 0 0 1-.23.073 1.48 1.48 0 0 1-.229.024c-.072 0-.157-.012-.242-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.678 37.277c-2.356 0-4.157-.858-5.075-2.405-.906-1.546-.785-3.54.363-5.606l7.322-13.171c1.208-2.175 2.876-3.372 4.713-3.372 1.836 0 3.504 1.197 4.712 3.372l7.323 13.183c1.147 2.066 1.28 4.048.362 5.606-.918 1.535-2.719 2.393-5.075 2.393H17.678zm4.193-20.3-7.31 13.183c-.822 1.474-.955 2.827-.387 3.806.568.979 1.824 1.51 3.516 1.51h14.645c1.692 0 2.936-.531 3.516-1.51.58-.979.435-2.32-.386-3.806L28.13 16.977c-.882-1.571-1.994-2.441-3.13-2.441-1.135 0-2.247.87-3.129 2.44z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorPink);
export default __webpack_public_path__ + "static/media/ic_error_pink.82585a88b5383c098f1b2f8789e4d513.svg";
export { ForwardRef as ReactComponent };